import { api } from "../api/Middleware";
import { ACCOUNT_URL } from "../api/Urls";

/**
 * Service para gerenciar as configurações globais da conta
 */

/**
 * Buscar configurações da conta
 * @returns {Promise} Response com as configurações
 */
export const getAccountSettings = async () => {
  try {
    const response = await api.get(`${ACCOUNT_URL}settings/`);
    return response;
  } catch (error) {
    console.error("Erro ao buscar configurações:", error);
    throw error;
  }
};

/**
 * Atualizar configurações da conta
 * Usa POST/PUT /api/account/settings/update/ 
 * Funciona com get_or_create para criar automaticamente se não existir
 * @param {Object} settings - Objeto com as configurações a serem atualizadas
 * @param {string} settings.api_key - API key global (opcional)
 * @returns {Promise} Response da atualização
 */
export const updateAccountSettings = async (settings) => {
  try {
    const response = await api.post(`${ACCOUNT_URL}settings/update/`, settings);
    return response;
  } catch (error) {
    console.error("Erro ao atualizar configurações:", error);
    throw error;
  }
};

/**
 * Criar ou atualizar apenas a API key global
 * Método específico para gerenciar a API key
 * @param {string} apiKey - API key a ser configurada
 * @returns {Promise} Response da operação
 */
export const updateApiKey = async (apiKey) => {
  try {
    const response = await api.post(`${ACCOUNT_URL}settings/update/`, {
      api_key: apiKey,
    });
    return response;
  } catch (error) {
    console.error("Erro ao atualizar API key:", error);
    throw error;
  }
};

/**
 * Remover API key global
 * @returns {Promise} Response da remoção
 */
export const removeApiKey = async () => {
  try {
    const response = await api.post(`${ACCOUNT_URL}settings/update/`, {
      api_key: null,
    });
    return response;
  } catch (error) {
    console.error("Erro ao remover API key:", error);
    throw error;
  }
};